import * as React from "react";
import Loading from "../../../ui/loading/Loading";
import Filter from "../../../../model/workspace/Filter";
import CustomField, {CustomFieldType} from "../../../../model/customField/CustomField";
import {option, Option} from "ts-option";
import {YesNo} from "../../../admin/customFields/BooleanDisplay";
import StringFilter from "../StringFilter";
import {EnumCustomFieldFilter} from "./EnumCustomFieldFilter";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import DateFilter from "../dateFilter/DateFilter";
import _ = require("underscore");

interface ComponentProps {
	filter: Filter
	onChange: (filter: Filter) => void;
	onRemove: (refreshData: boolean) => void;
	isFilterConfigVisible?: boolean;
}

interface ReduxProps {
	customField: Option<CustomField>
}

type Props = ComponentProps & ReduxProps

class CustomFieldFilter extends React.PureComponent<Props> {
	render() {
		const filter = this.filterCustomFieldIdFromValues(this.props.filter);
		return (
			<Loading isLoading={this.props.customField.isEmpty} spinnerSize={25}>
				{
					this.props.customField.map(cf => {
						if (cf.fieldType === CustomFieldType.STRING) {
							return <StringFilter onChange={this.onChange}
												 isFilterConfigVisible={this.props.isFilterConfigVisible}
												 onRemove={this.props.onRemove}
												 filter={filter}
												 negationDisable={true}/>;
						}
						else if (cf.fieldType === CustomFieldType.BOOLEAN) {
							return <EnumCustomFieldFilter onChange={this.onChange}
														  isFilterConfigVisible={this.props.isFilterConfigVisible}
														  onRemove={this.props.onRemove}
														  filter={filter}
														  items={option(_.values(YesNo))}/>;
						}
						else if (cf.fieldType === CustomFieldType.ENUM) {
							return <EnumCustomFieldFilter onChange={this.onChange}
														  isFilterConfigVisible={this.props.isFilterConfigVisible}
														  onRemove={this.props.onRemove}
														  filter={filter}
														  items={option(cf.options)}
														  selectAll/>;
						}
						else if (cf.fieldType === CustomFieldType.DATE) {
							return <DateFilter onChange={this.onChange}
											   isFilterConfigVisible={this.props.isFilterConfigVisible}
											   onRemove={this.props.onRemove}
											   filter={filter}/>;
						}
						else {
							return "Not supported custom field type"
						}
					}).getOrElse(<>Not implemented yet</>)}

			</Loading>
		)
	}

	onChange = (filter: Filter) => {
		this.props.customField.map(cf => {
			if (cf.fieldType === CustomFieldType.ENUM || cf.fieldType === CustomFieldType.BOOLEAN) {
				const values = filter.values.map((v: string[]) => [cf.id, ...v]);
				this.props.onChange(filter.copy({values}))
			}
			else {
				const values = filter.values.map((value: string) => [cf.id, value]);
				this.props.onChange(filter.copy({values}))
			}

		})
	};

	filterCustomFieldIdFromValues = (filter: Filter): Filter => {
		return this.props.customField.map(cf => {
			if (cf.fieldType === CustomFieldType.ENUM || cf.fieldType === CustomFieldType.BOOLEAN) {
				const values = filter.values.map((v: string[]) => {
					const tmp = [...v];
					tmp.shift()
					return tmp
				});
				return filter.copy({values})
			}
			else {
				const value = filter.values.flatMap((v: string[]) => option(v[1]));
				return filter.copy({values: value})
			}
		}).getOrElse(filter)
	}
}


function mapStateToProps(state: RootState, props: ComponentProps) {
	const jobCustomFields = state.customFields.jobCustomFields.getOrElse([]);
	const leadCustomFields = state.customFields.leadCustomFields.getOrElse([]);

	return {
		customField: option(
			_.find(leadCustomFields.concat(jobCustomFields), cf => cf.id === props.filter.columnDefinition.customFieldId.orNull))
	}
}

export default connect(mapStateToProps)(CustomFieldFilter)